import React, { useEffect, useRef, useState } from "react";
import { Flex, notification, InputNumber, Select } from "antd";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate } from "react-router-dom"

import {
  addEdit,
} from "../../../controllers/V1/salesAgentControllers";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { faArrowLeft, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {userList}  from  "../../../controllers/V1/invoice/invoiceControllers";
const UserListEditPage = () => {
  const { Option } = Select;
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ALLUSERSLIST, setAllUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(state?.bind_with || {});
  const [OPTIONS, setOptions] = useState([]);
  const [optionsLoading, setOptionsLoading] = useState(false);
  const [search_by, setSearchBy] = useState('');
  const handleSearchBy = (e)=>setSearchBy(e.target.value);

  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : {});

  const [isLoading, setIsLoading] = useState(false);

  /*********************** End ************************ */
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };
  /*********************************************************
   *  This function is used to handle phone number change
   *********************************************************/
  const handlePhoneChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      phone: value,
    }));
    setError((prev) => ({
      ...prev,
      phone: "", // Clear previous error message
    }));
  };
  /*********************************************************
   *  This function is used to handle phone code change
   *********************************************************/
  const handlePhoneCodeChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      country_code: value,
      phone: "", // Clear phone number
    }));
    setError((prev) => ({
      ...prev,
      phone: "", // Clear previous error message
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData(event.target);
      const param = {
        first_name : formData.get('first_name'), 
        last_name : formData.get('last_name'), 
        country_code : ADDEDITDATA?.country_code || "+971", 
        ...(ADDEDITDATA?._id ? { editId : ADDEDITDATA?._id }:{
          phone : ADDEDITDATA?.phone, 
        }),
        email : formData.get('email'),
        ...(formData.get('password') && {password : formData.get('password')}), 
        ...(formData.get('confirm_password') && {confirm_password : formData.get('confirm_password')}), 
        user_id : selectedUser?._id
      }
            
      if(!param?.first_name){
        notification.open({
          message: "Oops!",
          description: `First name is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else if(!param?.last_name){
        notification.open({
          message: "Oops!",
          description: `Last name is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else if(!param?.country_code){
        notification.open({
          message: "Oops!",
          description: `Country code is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else if(!param?.editId && !param?.phone){
        notification.open({
          message: "Oops!",
          description: `Phone number is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else if(!param?.editId && !param?.email){
        notification.open({
          message: "Oops!",
          description: `Email address is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else if(!param?.user_id){
        notification.open({
          message: "Oops!",
          description: `Please select sales person.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      } else if(!param?.editId && !param?.password){
        notification.open({
          message: "Oops!",
          description: `Password is required.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      } else if((param?.password || param?.confirm_password) && (param?.password !== param?.confirm_password)){
        notification.open({
          message: "Oops!",
          description: `Password and confirm password should be match.`,
          placement: "topRight",
          icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        });
      }else {
        
        const res = await addEdit(param);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />,
            duration: 2,
          });
          navigate("/sales-agent/list");
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
            duration: 2,
          });
        }
      } 
    } catch (error) {
      console.log("error", error);
    }
  };


  useEffect(() => {
    getUsersData();
    document.title = `U-Winn CRM || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Sales Agent`;
  }, []);

  const getUsersData = async (searchText='') =>{
    try {
      const option = {
        condition : { 
          // users_type : {"$in" : ["Sales Person", "Sales Supervisor"]}
          users_type : "Sales Person"
        },
        select : { users_type : true, users_name : true, last_name : true, users_mobile : true, users_email : true, users_mobile : true, store_name : true, area : true, bind_person_name : true, commission_percentage : true, users_id : true, pos_device_id : true, pos_number : true, due_amount : true },
        sort : {store_name : 1}
      }
      const res = await userList(option);
      if(res.status === true){
        setAllUsersList(res?.result || []);
      }
      setOptionsLoading(false);
    } catch (error) {
      
    }
  }

  const debounceTimeout = useRef(null);
  
    const handleSearch = (value) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        if (value.trim() !== "" && value.length > 3) {
          getUsersData(value);
        }
      }, 500); 
    };
  
    useEffect(()=>{
      if(ALLUSERSLIST.length > 0){
        const transformedArray = ALLUSERSLIST.map(user => ({
          label: `${user.users_name} | ${user.users_mobile}`,
          value: JSON.stringify(user) 
        }));
        setOptions(transformedArray);
      }
    },[ALLUSERSLIST]);
  
    const handleUserChange = (value) =>{
      try {
        setSelectedUser(JSON.parse(value));
      } catch (error) {
        
      }
    }


  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> {ADDEDITDATA?._id ? `Edit` : `Add`} Sales Agent </h5>
          </React.Fragment>
          <Link to={"/sales-agent/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <FontAwesomeIcon icon={faArrowLeft}/> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="first_name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>First Name :{" "}
                    </label>
                    <input
                      title="Enter your first name."
                      placeholder="Enter your first name."
                      type="text"
                      name="first_name"
                      className="form-control store_input_field"
                      id="first_name"
                      value={ADDEDITDATA?.first_name}
                      onChange={handleChange}
                    />
                    {error.first_name ? (
                      <p style={{ color: "red" }}>{error.first_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="last_name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Last Name :{" "}
                    </label>
                    <input
                      title="Enter your last name."
                      placeholder="Enter your last name."
                      type="text"
                      name="last_name"
                      className="form-control store_input_field"
                      id="last_name"
                      value={ADDEDITDATA?.last_name}
                      onChange={handleChange}
                    />
                    {error.last_name ? (
                      <p style={{ color: "red" }}>{error.last_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="email"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Email Address :
                    </label>
                    <input
                      title="Enter your email address."
                      placeholder="Enter your email address."
                      type="text"
                      name="email"
                      className="form-control store_input_field"
                      id="email"
                      value={ADDEDITDATA?.email}
                      onChange={handleChange}
                    />
                    {error.email ? (
                      <p style={{ color: "red" }}>{error.email}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="row">
                  {/* Second row: Phone Number and Department */}
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="phone"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Phone Number:
                    </label>
                    <br />
                    <InputNumber
                      style={{ width: "100%" }}
                      onChange={handlePhoneChange}
                      addonBefore={
                        <Select
                          defaultValue={"+971"}
                          style={{ width: 150 }}
                          onChange={handlePhoneCodeChange}
                        >
                          <Option value="+971" selected={true}>
                            +971 (UAE)
                          </Option>
                        </Select>
                      }
                      value={ADDEDITDATA?.phone}
                    />
                    {error.phone ? (
                      <p style={{ color: "red" }}>{error.phone}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Sales Person/Supervisor :
                    </label>
                    <Select
                      className="form-control"
                      defaultValue={
                        ADDEDITDATA?.bind_with && ({
                          label: `${ADDEDITDATA?.bind_with?.users_name} | ${ADDEDITDATA?.bind_with?.users_mobile}`,
                          value: JSON.stringify(ADDEDITDATA?.bind_with)})
                        }
                      onSearch={handleSearch}
                      onChange={handleUserChange}
                      showSearch={true}
                      defaultOpen={false}
                      autoClearSearchValue={false}
                      placeholder="Search to Select"
                      notFoundContent={null}
                      loading={optionsLoading}
                      options={OPTIONS}
                    />
                    {error.admin_first_name ? (
                      <p style={{ color: "red" }}>{error.admin_first_name}</p>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="password"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Password:
                    </label>
                    <input
                      title="Enter your password."
                      placeholder="Enter your password."
                      type="password"
                      name="password"
                      className="form-control store_input_field"
                      id="password"
                    />
                  </div>

                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="confirm_password"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Confirm Password:
                    </label>
                    <input
                      title="Enter your confirm password."
                      placeholder="Enter your confirm password."
                      type="password"
                      name="confirm_password"
                      className="form-control store_input_field"
                      id="confirm_password"
                    />
                  </div>                  
                </div>  
                <div className="inventory_edit_submit_btn">
                  <button type="submit" className="btn btn-primary inventory_save_button" > Save </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
